import useStore from "../../../../store"
import { MdOutlineStar } from "react-icons/md"
import { MdOutlineStarBorder } from "react-icons/md"
import { colors } from "../../../../utilities/colors"

export default function SaveDealerIcon({dealer}) {
  const savedDealers = useStore((state) => state.savedDealers)
  const createListDealer = useStore((state) => state.createListDealer)
  const isDealerSaved = savedDealers.some((savedDealer) => savedDealer.id === dealer.id)
  const removeListDealer = useStore((state) => state.removeListDealer)

  const handleSaveToList = (event) => {
    event.stopPropagation()
    createListDealer(dealer.id)
  }

  const handleRemoveFromList = (event) => {
    event.stopPropagation()
    removeListDealer(dealer.id)
  }

  return(
    <>
      {isDealerSaved ?
        <MdOutlineStar size={24} className="mr-2" data-testid="checkmark-icon" color={colors.green} onClick={handleRemoveFromList}/>
        :
        <MdOutlineStarBorder size={24} className="mr-2" data-testid="save-icon" onClick={handleSaveToList} />
      }
    </>
  )
}